<template>
	<div id="tranAm">
		<!--    <div class="bg-color-black">-->
		<div class="d-flex pt-2 pl-2" style="justify-content: space-between;align-items: center;">
			<span class="icon-cube" style="color:#5cd9e8;font-size: 0.3rem">
				<span class="fs-xl text mx-2" style="font-size: 0.25rem;color: #ffffff;font-weight: bold">高新技术企业名录</span>
			</span>
			<span @click="dialogVisible = true" style="font-size: 0.2rem;color: #ffffff;cursor: pointer;">更多+</span>
			<el-dialog title="高新技术企业名录" :visible.sync="dialogVisible" width="80%" center>
				<el-table :data="dataList" style="width: 95%;margin: 0 auto;" :header-cell-style="{background:'#043B95',color:'#fff','text-align':'center',}"
				:row-style="{background:'#043B95',color:'#fff'}">
					<el-table-column label="序号" :index="indexMethod" type="index"  width="60px" align="center">
<!--						<template slot-scope="scope">-->
<!--							<span>{{ scope.$index + 1 }}</span>-->
<!--						</template>-->
					</el-table-column>
					<el-table-column prop="enterpriseName" label="企业名称" align="center">
					</el-table-column>
					<el-table-column label='企业类别' prop='enterpriseType' align="center">
						<template slot-scope="scope">
							{{ scope.row.enterpriseType==1?'科技性企业':scope.row.enterpriseType==2?'科技型企业':'高新技术企业' }}
						</template>
					</el-table-column>
					<el-table-column prop="establishedTime" label="成立时间" width="180" align="center">
					</el-table-column>
					<el-table-column prop="industryList" label="技术领域" align="center">
						<template slot-scope="scope">
							{{ scope.row.industryList[0].industryName||'-'}}
						</template>
					</el-table-column>
					<el-table-column label='操作' align="center">
						<template slot-scope='scope'>
							<a @click="getDetail(scope.row.id)" style="color: #5cd9e8;cursor: pointer;">详情</a>
						</template>
					</el-table-column>


				</el-table>
				<el-pagination background :total='total' :current-page.sync='searchForm.pageNum' :page-size='searchForm.pageSize' @current-change='pageChange' class='pagination'
				layout='prev, pager, next'></el-pagination>
			</el-dialog>
			<el-dialog title="企业详情" :visible.sync="dialogFormVisible" width="80%" center :show-close="false">
				<a @click="goto" style="color: #5cd9e8;font-size: 16px;float: right;line-height: 40px;margin-top: -40px;cursor: pointer;">
					◀ 返回列表</a>
				<h2 style="color: #fff;height: 40px;text-align: center;clear: both;">{{ detail.enterpriseName }}</h2>
				<table class="Sta_table_one1" style="width: 90%;color: #fff;margin: 0 auto;">
					<thead>
						<tr>
							<td style="width: 140px;"></td>
							<td style="width: 220px;"></td>
							<td style="width: 100px;"></td>
							<td style="width: 270px;"></td>
							<td style="width: 100px;"></td>
							<td></td>
						</tr>
					</thead>
					<tbody>
						<tr>
							<td>法定代表人</td>
							<td>{{ detail.legalPersonName }}</td>
							<!-- <td>经营状态</td>
							<td>存续</td> -->
							<td>成立日期</td>
							<td>{{ detail.establishedTime }}</td>
							<td>注册资本</td>
							<td>{{ detail.registeredCapital }}</td>
						</tr>
						<tr>	<td style="display: inline-block;">统一社会信用代码</td>
							<td>{{ detail.unifiedCode }}</td>
							<td>企业类别</td>
							<td colspan="3">{{ detail.enterpriseType==1?'科技性企业':detail.enterpriseType==2?'科技型企业(入库)':'高新技术企业' }}</td>
<!--              <td>专利信息</td>-->
<!--              <td v-if="detail.enterprisePatentView&&detail.enterprisePatentView[0]!==null" style="color:#ff5e06;text-decoration: underline" @click="getPatent">点击查看专利信息</td>-->
<!--              <td v-else >-</td>-->
						</tr>

						<tr>

<td>企业类型</td>
							<td>{{ detail.enterpriseMold==1?'有限公司':'有限责任公司' }}</td>
							<td>技术领域</td>
							<td colspan="3">{{ detail.industryName||'-' }}</td>
						</tr>
						<tr>
							<td>地区</td>
							<td>{{ detail.areaDisplay }}</td>
							<td>地址</td>
							<td colspan="3">{{ detail.address }}</td>
						</tr>
						<tr>
							<td>经营范围</td>
							<td colspan="5" style="text-align: left;">
								{{ detail.businessScope }}
							</td>
						</tr>
					</tbody>
				</table>
        <el-table :data="detail.enterprisePatentView" style="width: 90%;margin: 0 auto;" :header-cell-style="{background:'#043B95',color:'#fff','text-align':'center',}"
                  :row-style="{background:'rgba(4, 59, 149, 0.8)',color:'#fff'}" height="300">
          <el-table-column label="序号"  width="60px" align="center">
            <template slot-scope="scope">
              <span>{{ scope.$index + 1 }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="patentName" label="专利名称" align="center">
          </el-table-column>
          <el-table-column label='专利类型' prop='patentTypeDisplay' align="center">
            <template slot-scope="scope">
              {{ scope.row.patentTypeDisplay }}
            </template>
          </el-table-column>
          <el-table-column label='专利申请号' prop='patentNum' align="center">
          </el-table-column>
          <el-table-column prop="empowerTime" label="授权发布时间" width="180" align="center">
          </el-table-column>
        </el-table>
			</el-dialog>
<!--      <el-dialog title="专利信息" :visible.sync="dialogVisible2" width="80%" center>-->
<!--        -->
<!--      </el-dialog>-->
		</div>
		<div class="d-flex jc-center body-box" style=" margin-top: 0.5rem;width:100%;height:90%;padding-bottom: 0.1rem">
			<!--        <dv-scroll-board :config="config" style="width:100%;height: 3rem" />-->
			<dv-scroll-board :config="config" @click="row" style="width:100%;height:100%" />
		</div>
	</div>
	<!--  </div>-->
</template>
<!-- import JavaScript -->

<script>
	import sciApi from '@/api/index.js'
	// import $ from 'jquery'
	export default {
		data() {
			return {
				dialogVisible: false,
        dialogVisible2: false,
        dialogFormVisible: false,
				videoUrl: '',
				// tableData:[],
				dataList: [],
				total: 0,
				searchForm: {
					pageSize:10,
          townStreet:'',
					pageNum:1,
          enterpriseType: '3'
				},
				detail: {},
				tum: [],
        enterprisePatentView:[],
				config: {
					header: ['<span style="font-weight: bold">企业名称</span>', '<span style="font-weight: bold">技术领域</span>','<span style="font-weight: bold">成立时间</span>'],
					data:[],
					// index: true,
					// indexHeader:'排名',
					headerHeight: 50,
					rowNum: 6,
					headerBGC: 'rgba(51, 109, 233, 0.5)',
					evenRowBGC: 'rgba(51, 109, 233, 0)',
					oddRowBGC: 'rgba(51, 109, 233, 0.2)',
					align: ['center', 'center', 'center'],
					columnWidth: [220],
				},

			};
		},
    watch:{
      // setregion:{
      //   immediate: true,
      //   deep: true,
      //   handler(val) {
      //     // this.searchForm.townStreet = val
      //   },
      // },
    },
		computed: {
      setregion() {
        return this.$store.state.region
      },
      indexMethod() {
        return (this.searchForm.pageNum - 1) * (this.searchForm.pageSize) + 1
      }
    },
		created() {},
		mounted() {
			this.init().then(() => {
				this.config = {
					header: ['<span style="font-weight: bold">企业名称</span>', '<span style="font-weight: bold">技术领域</span>','<span style="font-weight: bold">成立时间</span>'],
					// data:this.tum,
					headerHeight: 50,
					// data:[
					//   // ['重庆合利众恒科技有限公司','电子信息'],
					//   // ['重庆良顺汽车配件有限公司','先进制造与自动化'],
					//   // ['重庆奥维特机械制造有限公司','先进制造与自动化'],
					//   // ['重庆创瑞宏通科技有限公司','先进制造与自动化'],
					//   // ['重庆创想新瑞机械有限公司','先进制造与自动化'],
					//   // ['重庆卓润科技有限公司','先进制造与自动化'],
					//   // ['重庆南迅科技有限公司','新材料'],
					//   // ['重庆邦润环保科技有限公司','资源与环境'],
					// ],
					data: this.tum,
					rowNum: 6,
					// index: true,
					// indexHeader:'排名',
					headerBGC: 'rgba(51, 109, 233, 0.5)',
					evenRowBGC: 'rgba(51, 109, 233, 0)',
					oddRowBGC: 'rgba(51, 109, 233, 0.2)',
					align: ['center', 'center', 'center'],
					columnWidth: [260, 200,100],
				}
			})
		},
		methods: {
			async init() {
				await sciApi.selectMallListDataAll(
					this.searchForm
				).then((data) => {

					this.dataList = data.list || []
					this.total=data.total
					this.dataList.forEach((item) => {
            let num = []
						num.push(item.enterpriseName)
            if(item.industryList.length>0){
              num.push(item.industryList[0].industryName|| '-')
            }else {
              num.push('-')
            }
            num.push(item.establishedTime)
						num.push('<span style="display:none">'+ item.id + '</span>')
						// num.push(item.totalPrices)
            this.tum.push(num)
					})
				})
			},
      getPatent(){
        this.dialogVisible2 = true
        this.dialogFormVisible=false
      },
			pageChange() {
			this.init();
			},
			row(val){
				var id=val.row[3].replace(/[^0-9]/ig,"")
        console.log(id,'----val')
				this.getDetail(id);
			},
			goto() {
				this.dialogVisible = true
				this.dialogFormVisible = false
			},
			async getDetail(id) {
				this.detail = {}
				this.enterprisePatentView=[]
				await sciApi.mallListDetail({
					id: id
				}).then((data) => {
					this.detail = data
          this.enterprisePatentView=data.enterprisePatentView
          if(this.detail.industryList.length>0){
            this.detail.industryName = this.detail.industryList[0].industryName
          }else {
            this.detail.industryName='-'
          }
					this.dialogVisible = false
          this.dialogFormVisible = true
				})
			}
		}
	};
</script>

<style lang="scss">
.el-table--border::after {

  width: 0px;
}
.gutter{
  display:block !important;
}
.el-table__header-wrapper{
  background:none;
  }
	.el-pagination{
		margin-top: 30px;
		text-align: center;
	}
	// .el-pagination.is-background .el-pager li:not(.disabled).active {
	// background-color: rgba(4,59,149,0.8);
	// }
	.Sta_table_one1 tbody tr td:nth-child(2n-1) {
	background: rgba(4,59,149,0.8);
	color: #3FCAFA;
	vertical-align: middle;
	}
	.Sta_table_one1 tbody tr td {
	background: rgba(4,59,149,0.8);
	border: 1px solid rgba(38,111,232,0.5);
	padding: 10px;
	font-size: 16px;
	line-height: 24px;
	}
	#tranAm {
		padding: 0.2rem;
		width: 100%;
		height: 100%;

		//border-radius: 0.0625rem;
		.bg-color-black {
			padding: 0.0625rem;
			height: 4.5rem;
			border-radius: 0.125rem;
		}

		.text {
			color: #c3cbde;
		}

		.body-box {
			//border-radius: 0.125rem;
			overflow: hidden;
		}

		.head {
			background: rgba(255, 255, 255, 0.1);
			font-size: 18px;
			padding: 0.2rem;
			color: #68d8fe;
			display: flex;
			justify-content: space-between;
			line-height: 1.05;
		}

		.slideBox ul li {
			line-height: 36px;
			height: 36px;
			font-size: 16px;
			color: #4c9bfd;
			//padding: 0 0.2rem;
		}

		.slideBox ul li a {
			color: #4c9bfd !important;
			line-height: 40px;
			text-overflow: ellipsis;
			display: -webkit-box;
			-webkit-box-orient: vertical;
			-webkit-line-clamp: 1;
			overflow: hidden;
			width: 33%;
			text-align: left;
			float: left;
		}

		.slideBox ul li p {
			text-align: center;
			color: #4c9bfd !important;
			line-height: 40px;
			text-overflow: ellipsis;
			display: -webkit-box;
			-webkit-box-orient: vertical;
			-webkit-line-clamp: 1;
			overflow: hidden;
			width: 33%;
			float: left;
		}

		.slideBox ul li span {
			float: right;
			line-height: 40px;
			padding-right: 0.1rem;
		}
	}

	.el-dialog {
		background: rgba(51, 109, 233, 0.5) !important;
		color: #fff !important;
	}

	.el-dialog__title,
	.el-dialog__headerbtn .el-dialog__close {
		color: #fff !important;
		font-size: 0.25rem !important;
	}

	.el-table__body tr.current-row>td {
		background: #3FCAFA !important;
	}

	.el-table td,
	.el-table th.is-leaf,
	.el-table td,
	.building-top .el-table th.is-leaf {
		border-bottom: 1px solid rgba(38, 111, 232, 0.5);
		// border-right: 1px solid #5cd9e8!important;
	}

	.el-table::before {
		border-color: rgba(38, 111, 232, 0.5);
		display: none !important;
	}

	// .el-table--border  td, .el-table--border th, .el-table__body-wrapper .el-table--border.is-scrolling-left~.el-table__fixed {

	// }
	.el-table__body tr.current-row>td,
  .el-table, .el-table__expanded-cell{
  background-color: rgba(51, 109, 233, 0.5) !important
  }
	.el-table--enable-row-hover .el-table__body tr:hover>td {
		background: none !important;
	}
</style>
